import { render, staticRenderFns } from "./SessionsRegistrationLearnerPage.vue?vue&type=template&id=0f424414"
import script from "./SessionsRegistrationLearnerPage.vue?vue&type=script&lang=js"
export * from "./SessionsRegistrationLearnerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports